export enum InternationalFilterTab {
  AIRPORT = 'airport',
  VIA_COUNT = 'viaCount',
  FARE_TYPE = 'fareType',
  AIRLINE = 'airline',
  DURATION = 'duration',
}

export interface IFilterItem<T> {
  label: string;
  subLabel?: string;
  value: T;
  enable: boolean;
  selected: boolean;
}

export interface IFareTypeDetail {
  category: string;
  codeA: string;
  codeB: string;
  nameA: string;
  nameB: string;
  enable: boolean;
  selected: boolean;
}
